'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ConsentManager } from './ConsentManager';
const ConsentManagerContext = /*#__PURE__*/ createContext(null);
export const useConsentManager = ()=>{
    const context = useContext(ConsentManagerContext);
    if (!context) {
        throw new Error('No consent context provided.');
    }
    return context;
};
export const ConsentManagerProvider = ({ children })=>{
    const [_, setIsInitialized] = useState(false);
    const [{ getConsentStatus, getControllerId, initPromise, isUcInitialized }] = useState(()=>new ConsentManager());
    useEffect(()=>{
        window.UC_UI_DOMAINS = {
            crossDomainConsentSharingIFrame: 'https://www.lichtblick.de/cross-domain-bridge.html'
        };
        const updateOnInitialization = async ()=>{
            await initPromise;
            setIsInitialized(true);
        };
        updateOnInitialization();
    }, [
        initPromise
    ]);
    const context = useMemo(()=>({
            isUcInitialized: isUcInitialized,
            getConsentStatus: getConsentStatus,
            getControllerId: getControllerId
        }), [
        getConsentStatus,
        getControllerId,
        isUcInitialized
    ]);
    return /*#__PURE__*/ _jsx(ConsentManagerContext.Provider, {
        value: context,
        children: children
    });
};

//# sourceMappingURL=ConsentManagerProvider.js.map